import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from '../../components/StatsTable';
import API from '../../services/API';
import { PARAMS_NAME, NAN_PARAMS } from "./config";
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

class BidderNetworkPerformance extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            partnerValues: {},
            params: [],
            paramsObj: {},
            report: [],
            graphData: [],
            total: {},
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const date = new Date()
        const dateTo = date.toISOString().split('T')[0];

        date.setDate(date.getDate() - 8);

        const dateFrom = date.toISOString().split('T')[0];

        (async () => {
            const [ { report }, partners ] = await Promise.all(
                [
                    API.BidderNetworkPerformanceV2.get('daily', { dateFrom, dateTo }, 'graph'),
                    API.TrackerPartners.get()
                ]
            );

            this.setState({ loading: false, graphData: report, partnerValues: partners })
        })()
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === 'affid') return this.loadAffids(filters);
        if(type === 'subid') return this.loadSubids(filters);

        this.loadReport(filters, type);
    }

    loadReport(filters, type) {
        Promise.all([
            API.BidderNetworkPerformanceV2.get('daily', filters, type),
            API.BidderNetworkPerformanceV2.get('daily', filters, 'graph')
        ]).then(([ { params, report, total }, { report:graphData} ]) => {
            const paramsObj = params.reduce((obj, param, index) => {
                obj[param] = index;

                return obj;
            }, {});
            const newState = { params, paramsObj, report, graphData, total, isLoading: false };

            if(type === 'affid') {
                const affidIndex = paramsObj['affid'];
                newState.affidValues = report.map(row => row[affidIndex]);
            }

            this.setState(newState)
        })
    }

    loadSubids(filters) {
        API.BidderNetworkPerformanceV2.get('daily', filters, 'subid').then(({ subids }) => {
            this.setState({ isLoading: false,  subidValues: subids })
        });
    }

    loadAffids(filters) {
        API.BidderNetworkPerformanceV2.getAffids('daily', filters).then(({ affids }) => {
            this.setState({ isLoading: false,  affidValues: affids })
        });
    }

    getGraph() {
        const { graphData } = this.state;
        if(!graphData.length) return;

        return (
            <ResponsiveContainer width={'100%'} height={300}>
                <LineChart
                    width={500}
                    height={300}
                    data={graphData}
                    margin={{
                        top: 5, right: 30, left: 20, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis yAxisId="left" />
                    <YAxis yAxisId="right" orientation="right"/>
                    <Tooltip/>
                    <Legend/>
                    <Line yAxisId="left" type="linear" dataKey="spend" stroke="#ff0000" dot={{ stroke: '#ff0000', strokeWidth: 3 }} activeDot={{ stroke: '#ff0000', strokeWidth: 3 }} strokeWidth={3}/>
                    <Line yAxisId="left" type="linear" dataKey="roi" stroke="#008000" dot={{ stroke: '#008000', strokeWidth: 3 }} activeDot={{ stroke: '#008000', strokeWidth: 3 }} strokeWidth={3} />
                    <Line yAxisId="right" type="linear" dataKey="percentRoi" stroke="#5c00e6" dot={{ stroke: '#5c00e6', strokeWidth: 3 }} activeDot={{ stroke: '#5c00e6', strokeWidth: 3 }} strokeWidth={3} />
                </LineChart>
            </ResponsiveContainer>
        );
    }

    render() {
        const { isLoading, affidValues, subidValues, partnerValues, params, paramsObj, report, total } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder Network Performance V2"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues} partnerValues={partnerValues} />
                {this.getGraph()}

                <Table params={params} paramsObj={paramsObj} report={report} total={total} paramNames={PARAMS_NAME} NaNParams={NAN_PARAMS}/>
            </Container>
        );
    }
}

export default BidderNetworkPerformance;



// WEBPACK FOOTER //
// ./src/scenes/BidderNetworkPerformanceV2/index.js